import styled, { css } from 'styled-components';
import timesIcon from '../../../images/times.svg';

const COLORS = {
  info: '#F09E00',
};

export default {
  Container: styled.div<{ isPeriodical: boolean }>`
    position: absolute;
    top: ${(props) => (props.isPeriodical ? 100 : 81)}px;
    right: 16px;
    width: 280px;
    z-index: 9990;

    ${(props) =>
      props.theme.isRtl &&
      css`
        right: unset;
        left: 16px;
      `}

    @media screen and (max-width: 700px) {
      top: ${(props) => (props.isPeriodical ? 110 : 100)}px;
    }
  `,

  Message: styled.div<{ type: string }>`
    position: relative;
    padding: 12px 16px 12px 40px;
    margin-bottom: 8px;
    border: 1px solid;
    box-sizing: border-box;
    box-shadow: 0px 16px 40px rgba(122, 91, 30, 0.08);
    border-radius: 8px;
    border-color: ${(props) => COLORS[props.type]};
    background-color: #fff;
    background-image: url(${timesIcon});
    background-repeat: no-repeat;
    background-position: right 9px top 9px;
    box-sizing: border-box;
    font-size: 14px;
    line-height: 18px;
    color: rgba(0, 0, 0, 0.64);

    ${(props) =>
      props.theme.isRtl &&
      css`
        padding-right: 40px;
        padding-left: 16px;
        background-position: left 9px top 9px;
      `}

    &:hover {
      cursor: pointer;
    }
  `,

  Title: styled.div`
    font-size: 14px;
    line-height: 18px;
    color: #000;
    margin-bottom: 4px;
  `,

  Icon: styled.img`
    position: absolute;
    top: 14px;
    left: 14px;

    ${(props) =>
      props.theme.isRtl &&
      css`
        right: 14px;
        left: unset;
      `}
  `,
};
